import { useEffect, useState } from 'react';
import { getDisplayCurrency, subscribeDisplayCurrency, fmtMoney } from '@/lib/currency';

/**
 * useDisplayCurrency — React hook that re-renders the calling component whenever
 * the user changes their base currency in Settings. Returns the current currency
 * code (e.g. "INR") plus a memoised `fmt` formatter bound to it.
 */
export function useDisplayCurrency() {
  const [ccy, setCcy] = useState(() => getDisplayCurrency());
  useEffect(() => subscribeDisplayCurrency(setCcy), []);
  const fmt = (n, override = null, opts) => fmtMoney(n, override || ccy, opts);
  return { ccy, fmt };
}
